<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-249f9abc="" class="content clearfix">
      <div class="main">
        <h1 style="margin-bottom: 20px;">报修</h1>
        <div>
          <div class="main">
            <form class="el-form demo-ruleForm">
              <div class="el-form-item is-required">
                <!---->
                <div class="el-form-item__content">
                  <div class="certificate_type">
                    <div class="el-row">
                      <div class="el-col el-col-5">问题类型</div>
                      <div class="el-col el-col-19">
                        <div class="el-select el-select--medium">
                          <!---->
                          <div class="el-input el-input--medium el-input--suffix">
                            <input type="text" readonly="readonly" autocomplete="off" placeholder="请选择" class="el-input__inner">
                            <span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>

                              </span>
                              <!---->
                            </span>
                            <!---->
                            <!---->
                          </div>
                          <div class="el-select-dropdown el-popper" style="display: none; min-width: 150px;">
                            <div class="el-scrollbar" style="">
                              <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                                <ul class="el-scrollbar__view el-select-dropdown__list">
                                  <!---->
                                  <li class="el-select-dropdown__item"><span>给水管</span></li>
                                  <li class="el-select-dropdown__item"><span>阀门</span></li>
                                  <li class="el-select-dropdown__item"><span>停水</span></li>
                                  <li class="el-select-dropdown__item"><span>水压</span></li>
                                  <li class="el-select-dropdown__item"><span>水表</span></li>
                                  <li class="el-select-dropdown__item"><span>水质</span></li>
                                  <li class="el-select-dropdown__item"><span>消防栓</span></li>
                                  <li class="el-select-dropdown__item"><span>井盖</span></li>
                                  <li class="el-select-dropdown__item"><span>排水管</span></li>
                                  <li class="el-select-dropdown__item"><span>排水井</span></li>
                                  <li class="el-select-dropdown__item"><span>其他</span></li>
                                </ul>
                              </div>
                              <div class="el-scrollbar__bar is-horizontal">
                                <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                              </div>
                              <div class="el-scrollbar__bar is-vertical">
                                <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                              </div>
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </div>
              </div>
              <div class="el-form-item recover_title is-required">
                <!---->
                <div class="el-form-item__content">
                  <div class="certificate_reason">
                    <div class="el-row">
                      <div class="reason el-col el-col-5">问题描述</div>
                      <div class="el-col el-col-19">
                        <div class="el-textarea"><textarea autocomplete="off" placeholder="请输入问题具体情况" maxlength="800" class="el-textarea__inner"
                                    style="resize: none; min-height: 44px;"></textarea><span class="el-input__count">0/800</span></div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </div>
              </div>
              <div class="certificate_type">
                <div class="el-row">
                  <div class="reason el-col el-col-5">照片（选填）</div>
                  <div class="el-col el-col-19">
                    <ul class="upload-img clearfix" style="min-height: 100px;">
                      <li><input type="file" id="uploadFile" accept="image/*" class="upload-imgs" style="display: none;"> <label for="uploadFile" class="upload-imgs"><button type="button"
                                  class="el-button el-button--primary" style="pointer-events: none;">
                            <!---->
                            <!----><span>+ 添加照片</span>
                          </button></label></li>
                    </ul>
                    <!---->
                  </div>
                </div>
              </div>
              <div class="el-form-item is-required">
                <!---->
                <div class="el-form-item__content">
                  <div class="certificate_type">
                    <div class="el-row">
                      <div class="el-col el-col-5">所在区域</div>
                      <div class="el-col el-col-19">
                        <div class="el-select el-select--medium">
                          <!---->
                          <div class="el-input el-input--medium el-input--suffix">
                            <!----><input type="text" readonly="readonly" autocomplete="off" placeholder="请选择" class="el-input__inner">
                            <!----><span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                                <!---->
                                <!---->
                                <!---->
                                <!---->
                                <!---->
                              </span>
                              <!---->
                            </span>
                            <!---->
                            <!---->
                          </div>
                          <div class="el-select-dropdown el-popper" style="display: none; min-width: 150px;">
                            <div class="el-scrollbar" style="">
                              <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                                <ul class="el-scrollbar__view el-select-dropdown__list">
                                  <!---->
                                  <li class="el-select-dropdown__item"><span>福田区</span></li>
                                  <li class="el-select-dropdown__item"><span>罗湖区</span></li>
                                  <li class="el-select-dropdown__item"><span>罗湖区-莲塘</span></li>
                                  <li class="el-select-dropdown__item"><span>南山区</span></li>
                                  <li class="el-select-dropdown__item"><span>盐田区</span></li>
                                  <li class="el-select-dropdown__item"><span>宝安区</span></li>
                                  <li class="el-select-dropdown__item"><span>龙岗区</span></li>
                                  <li class="el-select-dropdown__item"><span>龙岗区-坪地</span></li>
                                  <li class="el-select-dropdown__item"><span>龙华区</span></li>
                                  <li class="el-select-dropdown__item"><span>坪山区</span></li>
                                  <li class="el-select-dropdown__item"><span>光明区</span></li>
                                  <li class="el-select-dropdown__item"><span>大鹏新区</span></li>
                                  <li class="el-select-dropdown__item"><span>大鹏新区-南澳</span></li>
                                </ul>
                              </div>
                              <div class="el-scrollbar__bar is-horizontal">
                                <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                              </div>
                              <div class="el-scrollbar__bar is-vertical">
                                <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                              </div>
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </div>
              </div>
              <div class="el-form-item recover_title is-required">
                <!---->
                <div class="el-form-item__content">
                  <div class="certificate_type">
                    <div class="el-row">
                      <div class="el-col el-col-5">联系人</div>
                      <div class="el-col el-col-19">
                        <div class="certificate_phone el-input">
                          <!----><input type="text" autocomplete="off" placeholder="请输入" class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </div>
              </div>
              <div class="el-form-item recover_title is-required">
                <!---->
                <div class="el-form-item__content">
                  <div class="certificate_type">
                    <div class="el-row">
                      <div class="el-col el-col-5">联系手机号</div>
                      <div class="el-col el-col-19">
                        <div class="certificate_phone el-input">
                          <!----><input type="text" autocomplete="off" maxlength="11" minlength="11" placeholder="请输入" class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </div>
              </div>
              <div class="el-form-item recover_title is-required">
                <!---->
                <div class="el-form-item__content">
                  <div class="certificate_type">
                    <div class="el-row">
                      <div class="el-col el-col-5">联系地址</div>
                      <div class="el-col el-col-19">
                        <div class="certificate_phone el-input">
                          <!----><input type="text" autocomplete="off" placeholder="请输入" class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---->
                </div>
              </div>
              <div class="el-form-item">
                <!---->
                <div class="el-form-item__content">
                  <div class="greyBtnWrap"><button disabled="disabled" type="button" class="el-button el-button--primary is-disabled">
                      <!---->
                      <!----><span>提交</span>
                    </button></div>
                  <!---->
                </div>
              </div>
            </form>
          </div>
          <!---->
        </div>
        <!---->
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>